/** The brand the portal is built in (packages/tokens/feratelaiplus.css, TL decision 2026-10-05). */
export const BRAND = "feratelAIplus";
